import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SentenceElementVerballed = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 14),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 1.5,
    strokeWidth: "8",
    children: /*#__PURE__*/jsx("g", {
      transform: "matrix(1.06723,0,0,1.06723,-6.84143,1.52299)",
      children: /*#__PURE__*/jsx("circle", {
        cx: "53.261",
        cy: "45.423",
        r: "40.847"
      })
    })
  });
};

export { SentenceElementVerballed };
//# sourceMappingURL=sentence-element.verballed.js.map
